import PageLoader from "./PageLoader";
import LoadingSpinner from "./Loading/LoadingSpinner";
import {useTranslation} from "react-i18next";
import React from "react";

export const Fallback = ({ children }) => <>{children}</>;
const ConditionalRender = ({condition, showLoading = false, pageLoader = false, fallback, children}) => {
    const {t} = useTranslation()

    // Check if a Fallback component is present among children
    const childrenFallback = React.Children.toArray(children).find(child => child.type === Fallback);

    if(condition)
        // return children;
        return React.Children.map(children, child => (child.type !== Fallback ? child : null));
    else if(fallback)
        return fallback;
    else if (childrenFallback)
        return childrenFallback;


    if(showLoading)
    {
        return pageLoader ? <PageLoader className={'mt-2'} text={t("global.states.loading") + '...'}/> : <LoadingSpinner className={'mt-2'} text={t('global.states.loading')  + '...'}/>;
    }

    return null;
};

export default ConditionalRender;